// Copy paste from example in documentation
// See https://jqueryui.com/autocomplete/#categories
$.widget('custom.autocompleteCustomer', $.ui.autocomplete, {
    _create() {
        this._super();
    },
    _renderMenu(ul, items) {
        ul.addClass('M-customerAutocomplete__menu');
        $.each(items, (index, item) => {
            const li = this._renderItemData(ul, item);
            li.attr('aria-label', `${item.label}`);
        });
    },
    _renderItem(ul, item) {
        return $('<li class="M-searchAutocomplete__menuItem">').html(item.labelHtml).appendTo(ul);
    },
});

Bingo.CustomerAutocomplete = class {
    constructor($wrapper, options) {
        const defaults = {
            btnClearSelector: '.js-textField__searchReset',
            filledClass: '-filled',
            inputNames: ['firstname', 'lastname', 'email', 'phone'],
            labelItems: ['firstname', 'lastname', 'email', 'phone'],
            customerInputSelector: '[name="customer_id"]',
            namespace: null,
            isForCompany: false,
            companyIdSelector: null,
            additionalClear: [],
        };

        this.options = $.extend(defaults, options);
        this.wrapper = $wrapper;
        this.btnClear = $wrapper.find(this.options.btnClearSelector);
        this.searchUrl = this.wrapper.attr('data-customer-autocomplete-search-url');
        this.customerInput = $wrapper.find(this.options.customerInputSelector);
        this.inputs = [];
        for (const i in this.options.inputNames) {
            let name = this.options.inputNames[i];
            if (this.options.namespace) {
                name = this.options.namespace.concat('[', name, ']');
            }
            this.inputs.push($wrapper.find("[name='".concat(name, "']")));

            //  Add proxy field if exist
            const proxyInput = $wrapper.find("[name='".concat(`${name}_proxy`, "']"));
            if (proxyInput.length > 0) {
                this.inputs.push(proxyInput);
            }
        }

        this.btnClear.on('click', (e) => {
            e.stopImmediatePropagation();
            this.clearAutocomplete();
        });

        for (const i in this.inputs) {
            this.inputs[i].autocompleteCustomer({
                minLength: 3,
                delay: 500,
                source: (request, response) => {
                    // Load new suggestions
                    this.loadSuggestions(request.term, this.inputs[i].attr('name')).then((data) => {
                        response(data); // Update jquery autocomplete
                    });
                },
                select: (event, ui) => {
                    const data = ui.item.data;
                    this.wrapper.data('selected-item', data);
                    this.selectSuggestion(data, this.options.namespace);
                    return false;
                },
                position: {
                    my: 'left+0 top+2',
                },
            });
        }
    }

    /**
     * Loads new suggestions from API
     * @param text Search phrase
     * @param fieldName Field name
     * @return Promise
     */
    loadSuggestions(text, fieldName) {
        removeBracket = (textToRemove) => {
            if (textToRemove.includes('[') && textToRemove.includes(']')) {
                return removeBracket(textToRemove.match(/\[(.*?)\]/)[1]);
            }
            // Remove _proxy postfix
            if (textToRemove.includes('_proxy')) {
                textToRemove = textToRemove.replace('_proxy', '');
            }
            return textToRemove;
        };

        ajaxData = {
            field: removeBracket(fieldName),
            value: text,
            forCompany: this.options.isForCompany ? 1 : 0,
        };

        if (this.options.isForCompany && $(this.options.companyIdSelector).val()) {
            ajaxData.companyId = $(this.options.companyIdSelector).val();
        }

        return $.nette.ajax({
            type: 'GET',
            url: this.searchUrl,
            data: ajaxData,
        }).then((payload, status, jqXHR) => {
            if (payload.status.code !== 1) {
                Bingo.AjaxFailed.showError(payload.status.message);
                return $.Deferred().reject(jqXHR); // Reject promise
            }

            return payload.data;
        }).then((suggestions) => {
            let data = [];

            // Transform API response to data for autocomplete [{label, category, data}]
            for (const i in suggestions) {
                const suggestedData = suggestions[i];
                let suggest = this.options.labelItems.map(item => suggestions[i][item]);
                suggest = suggest.filter(element => element != null);

                const suggestDescription = suggest.join(', ');

                data = data.concat({
                    label: suggestedData[fieldName],
                    labelHtml: this.constructor.highlightSearchText(suggestDescription, text),
                    description: suggestDescription,
                    data: suggestedData,
                });
            }
            return data;
        });
    }

    /**
     * @param data
     */
    selectSuggestion(data, namespace) {
        // find all dropdown filters and set their values to null without sending a server request for their onChange events
        $('select.js__filter-select').each(function () {
            $(this).data('filter-send-request', 'false');
            $(this)[0].selectize.setValue(null);
            $(this).data('filter-send-request', 'true');
        });
        const camelToUnderscore = camelText => camelText.replace(/(?:^|\.?)([A-Z])/g, (x, y) => '_'.concat(y.toLowerCase())).replace(/^_/, '');

        if (data.id) {
            this.customerInput.val(data.id);
        }

        for (const name in data) {
            if (typeof data[name] === 'object' && data[name] !== null) {
                this.selectSuggestion(data[name], camelToUnderscore(name));
            }
            let inputName = camelToUnderscore(name);
            if (namespace) {
                inputName = namespace.concat('[', inputName, ']');
            }
            const input = this.wrapper.find("[name='".concat(inputName, "']"));

            if (input) {
                if (input.attr('type') === 'radio') {
                    input.each((index, item) => {
                        if ($(item).attr('value') === data[name].toString()) {
                            $(item).prop('checked', true).trigger('change');
                        }
                    });
                } else if (input.hasClass('mdb-select')) {
                    if (data[name] !== null) {
                        const optionName = input.find(`option[value="${data[name]}"]`).text();
                        input.parent().find(`li:contains("${optionName}")`).click();
                    } else {
                        input.parent().find('li:first-child').click();
                    }
                } else if (inputName === 'address[country]') {
                    input[0].selectize.setValue(data[name]);
                    input.trigger('change').trigger('updateProxyValue');
                } else {
                    input.val(data[name]).trigger('change').trigger('updateProxyValue');
                }
            }
        }

        this.disable();
    }

    /**
     * Clear autocomplete
     */
    clearAutocomplete() {
        this.clear();
    }

    /**
     * Disable search input
     */
    disable() {
        this.inputs.forEach((input) => {
            input.prop('disabled', true);
            input.closest('.js-textField').addClass(this.options.filledClass);
        });

        if (this.options.additionalClear.length > 0) {
            this.options.additionalClear.forEach((item) => {
                const inputs = $(item).find('input:text, input[type="date"]');
                inputs.each((index, input) => {
                    $(input).prop('disabled', true);
                    $(input).closest('.js-textField').addClass(this.options.filledClass);
                });
            });
        }
    }

    /**
     * Clear search input
     */
    clear() {
        this.inputs.forEach((input) => {
            input.val('');
            input.prop('disabled', false);
            input.prop('checked', false);
            input.trigger('change');
            input.closest('.js-textField').removeClass(this.options.filledClass);
        });
        if (this.options.additionalClear.length > 0) {
            this.options.additionalClear.forEach((item) => {
                const inputs = $(item).find('input:text, input[type="date"]');
                inputs.each((index, input) => {
                    $(input).val('');
                    $(input).prop('disabled', false);
                    $(input).prop('checked', false);
                    $(input).trigger('change');
                    $(input).closest('.js-textField').removeClass(this.options.filledClass);
                });
            });
        }
        this.wrapper.data('selected-item', null);
        this.customerInput.val('');
    }

    /**
     * Returns html string with search text wrapped in <strong>
     * @param suggestion
     * @param searchText
     * @return string
     */
    static highlightSearchText(suggestion, searchText) {
        const searchTextEsc = '('.concat(searchText.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), ')');
        return suggestion.replace(new RegExp(searchTextEsc, 'ig'), '<strong>$1</strong>');
    }
};
